import React from 'react'
import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { Divider, Typography } from '@mui/material'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'

const ListWrapper = styled.div`
  padding: ${Shapes.spacing[0]}px ${Shapes.spacing[0]}px;
  padding-bottom: ${Shapes.spacing[4]}px;
  :last-of-type {
    padding-bottom: 0;
  }
`

const ListTitle = styled.div``
const ListTitleText = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: ${Shapes.spacing[4]}px;
  padding-inline: ${Shapes.spacing[4]}px;
`

const List = styled.div``

type TitledListProps = {
  children?: React.ReactNode
  title: React.ReactNode
  clearable?: boolean
  onClear?: () => void
  style?: React.CSSProperties
  titleStyle?: React.CSSProperties
  titleTextStyle?: React.CSSProperties
  listStyle?: React.CSSProperties
}
export const TitledList = (props: TitledListProps) => {
  const { title, clearable, onClear, children, style, titleStyle, titleTextStyle, listStyle: listStyleProp } = props
  const listStyle = title ? { ...listStyleProp } : { paddingTop: 0, ...listStyleProp }
  return (
    <ListWrapper style={style}>
      {title && (
        <ListTitle style={titleStyle}>
          <ListTitleText style={titleTextStyle}>
            {typeof title === 'string' ? <Typography variant="title2">{title}</Typography> : title}
            {clearable && (
              <ButtonWithIcon color={Colors.textDark} onClick={onClear}>
                Clear
              </ButtonWithIcon>
            )}
          </ListTitleText>
          <Divider />
        </ListTitle>
      )}
      <List style={listStyle}>{children}</List>
    </ListWrapper>
  )
}
